baseApp.directive('dash2',  [function() {
    return {
        templateUrl: '/public/directives/dash2.html',
        scope: {
            fulldata: '=',
            olddata: '=',
            rtinterval: '=',
            from: '=',
            to: '=',
            currentcounter: '=?',
            graphinterval: '=',
            filtereddata: '=',
            nozoom: '=?',
            elementid: '@',
            chartscroll: '@?',
            miniview: '@?',
            hidescroll: '@?',
            alternativeticks: '@?',
            marginright: '@',
            legend: '='
        },
        controller: ['$scope', '$interval','$filter' ,function($scope, $interval,$filter) {
            var trafficChart;
            var rtMargin = 0;

            $scope.loaded = true;

            angular.element(document).ready(function() {
                if(!$scope.loaded){
                    return;
                }

                if(!trafficChart) {
                    drawChart();
                    updateChart();
                }
            });

            var realtimeUpdateInterval;

            var tempData = {
                dateTime: new Date(),
                linecolor: 1,
                alphaField: 0,
                size: 0
            };

            $scope.$watch('fulldata', function(newData, olddata) {
                if($scope.rtinterval){
                    return;
                }

                if (newData && !_.isEqual(newData, olddata)) {
                    if(trafficChart){
                        updateChart(newData);
                    }
                    else {
                        drawChart();
                        updateChart(newData);
                    }
                }
            }, true);

            $scope.$watch('filtereddata', function(newData, olddata) {
                if (newData && !_.isEqual(newData, olddata)) {
                    if(trafficChart){
                        if(newData.length > 0){
                            var counter = 0, chartData = _.cloneDeep($scope.fulldata);
                            chartData.forEach(function(item){
                                if(newData[counter] && item.dateTime && item.dateTime.getTime && newData[counter].dateTime.getTime() === item.dateTime.getTime()){
                                    item.size2 = 0 + newData[counter].size;
                                    item.label2 = newData[counter].label;
                                }
                                counter++;
                            });
                            updateChart(chartData);
                        }
                        else {
                            updateChart($scope.fulldata);
                        }
                    }
                }
            }, true);

            $scope.$watch('rtinterval', function(newData){
                if(newData){
                    realtimeUpdateInterval = $interval(updateRealtime, $scope.rtinterval/2);
                }
                else {
                    if(realtimeUpdateInterval){
                        $interval.cancel(realtimeUpdateInterval);
                    }

                }
            });


            $scope.clearZoom = function() {
                $scope.from = null;
                $scope.to = null;
                trafficChart.chartCursor.clearSelection();
            };

            function updateRealtime(){

                if(!$scope.rtinterval || !$scope.fulldata || !$scope.olddata){
                    return;
                }

                //rtMargin = 20 - $scope.fulldata.length;
                if($scope.fulldata.length < 20 && $scope.olddata.length === 0) {
                    rtMargin = -1;

                    if($scope.fulldata.length > 0) {
                        $scope.olddata.unshift({
                            dateTime: new Date($scope.fulldata[0].dateTime.getTime() - ($scope.rtinterval)),
                            linecolor: 1,
                            alpha: 0,
                            fillColorsField: "white",
                            size: $scope.fulldata[0].size
                        });
                    }
                    else {
                        $scope.olddata.unshift({
                            dateTime: new Date(new Date().getTime() - ($scope.rtinterval)),
                            linecolor: 1,
                            alpha: 0,
                            fillColorsField: "white",
                            size: 0
                        });
                    }
                    for (var k = 1; k < 20; k++) {
                        $scope.olddata.unshift({
                            dateTime: new Date($scope.olddata[0].dateTime.getTime() - $scope.rtinterval),
                            linecolor: 1,
                            alpha: 0,
                            fillColorsField: "white",
                            size: $scope.fulldata[0] ? $scope.fulldata[0].size : 0
                        });
                    }
                }
                else {
                    rtMargin = 1;
                }

                if($scope.fulldata.length > 0) {
                    var newData = $scope.fulldata.shift();
                    newData.linecolor = 0;
                    $scope.olddata.push(newData);
                }
                else if($scope.olddata.length>0){
                    $scope.olddata.push({
                        dateTime: new Date($scope.olddata[$scope.olddata.length-1].dateTime.getTime() + ($scope.rtinterval)),
                        size: $scope.olddata[$scope.olddata.length-1].size,
                        counters: $scope.olddata[$scope.olddata.length-1].counters,
                        linecolor: $scope.olddata[$scope.olddata.length-1].linecolor,
                        fillColorsField: $scope.olddata[$scope.olddata.length-1].fillColorsField,
                        label: $scope.olddata[$scope.olddata.length-1].label
                    });

                }

                if($scope.olddata.length>20){
                    $scope.olddata.shift();
                }


                $scope.olddata = _.uniq($scope.olddata, function(item){
                    return item.dateTime.getTime();
                });
                $scope.olddata = _.sortBy($scope.olddata, 'dateTime');

                if(trafficChart){
                    updateChart($scope.olddata);
                }
                else {
                    drawChart($scope.olddata);
                }
            }



            var chartScrollbar = {};
            if($scope.chartscroll){
                chartScrollbar = {
                    "graph": "AmGraph-1",
                    "oppositeAxis":false,
                    "offset":30,
                    "scrollbarHeight": 80,
                    "backgroundAlpha": 0,
                    "selectedBackgroundAlpha": 0.1,
                    "selectedBackgroundColor": "#888888",
                    "graphFillAlpha": 0,
                    "graphLineAlpha": 0.5,
                    "selectedGraphFillAlpha": 0,
                    "selectedGraphLineAlpha": 1,
                    "autoGridCount":true,
                    "color":"#AAAAAA"
                };
            }

            $scope.adjustballoontext = function(graphDataItem, graph){
                var label = (graphDataItem.values.value === graphDataItem.serialDataItem.dataContext.size) ? graphDataItem.serialDataItem.dataContext.label : graphDataItem.serialDataItem.dataContext.label2;
                if(label){
                    if(typeof label === "function"){
                        return label(graphDataItem);
                    }
                    else {
                        return label;
                    }

                }
                else {
                    return $filter('number')(graphDataItem.values.value);
                }
            };

            $scope.adjustValueAxisLabels = function(value, valueText, valueAxis){
                if($scope.currentcounter && $scope.currentcounter.labelFunc){
                    return($scope.currentcounter.labelFunc(value));
                }
                else {
                    return value;
                }
            };


            function drawChart(data){

                trafficChart = AmCharts.makeChart($scope.elementid,
                    {
                        "type": "serial",
                        "path": "/public/javascripts/external/amcharts/",
                        "pathToImages": "/public/javascripts/external/amcharts/images/",
                        "categoryField": "dateTime",
                        theme: "new",
                        fontFamily: 'Roboto',
                        addClassNames: true,
                        /* autoMarginOffset: $scope.miniview? 0 : 10,*/
                        marginRight: $scope.marginright? $scope.marginright : $scope.miniview? 0 : 5,
                        "categoryAxis":{
                            gridAlpha: 0.15,
                            "minPeriod": "2500fff",
                            //minorGridEnabled: false,
                            minHorizontalGap: $scope.alternativeticks ? 30 : 75,
                            markPeriodChange: $scope.alternativeticks ? false : true,
                            "parseDates": true,
                            labelsEnabled: !$scope.miniview,
                            dateFormats: [{period:'fff',format:'JJ:NN:SS'},{period:'ss',format:'JJ:NN:SS'},{period:'mm',format:'JJ:NN'},{period:'hh',format:'JJ:NN'},{period:'DD',format:'MMM DD'},{period:'WW',format:'MMM DD'},{period:'MM',format:'MMM'},{period:'YYYY',format:'YYYY'}]

                        },
                        "chartScrollbar": $scope.miniview || $scope.hidescroll? false : chartScrollbar,
                        "chartCursor": {
                            cursorPosition: "mouse",
                            selectWithoutZooming: true,
                            "categoryBalloonDateFormat": "JJ:NN:SS, MMM DD, YYYY"
                        },
                        "trendLines": [],
                        "legend":  {
                            position: "absolute",
                            useGraphSettings: true,
                            enabled: true,
                            valueText: ""
                        },
                        "graphs": [
                            {
                                "lineThickness": 2,
                                "dateFormat": "JJ:NN:SS DD, YYYY",
                                "fillAlphas": 0.33,
                                labelsEnabled: !$scope.miniview,
                                "fontSize": 4,
                                "id": "AmGraph-1",
                                "alphaField": "alpha",
                                "type": "column",
                                //"lineColorField": "linecolor",
                                //fillColorsField: "fillColorsField",
                                "showOnAxis": !$scope.miniview,
                                "title": $scope.miniview? "" : "IP Packets ",
                                "valueField": "size",
                                "balloonFunction" : $scope.adjustballoontext
                            },
                            {
                                "lineThickness": 2,
                                "dateFormat": "JJ:NN:SS DD, YYYY",
                                "fillAlphas": 0.5,
                                "fontSize": 4,
                                "id": "AmGraph-2",
                                "alphaField": "alpha2",
                                //"lineColorField": "linecolor",
                                "type": "column",
                                //fillColorsField: "fillColorsField2",
                                "showOnAxis": !$scope.miniview,
                                "title": $scope.miniview? "" : "IP Packets ",
                                "valueField": "size2",
                                "balloonFunction" : $scope.adjustballoontext
                            }
                        ],
                        "guides": [],
                        "valueAxes": [
                            {
                                "id": "ValueAxis-1",
                                "title": $scope.miniview? "" : "IP Packets ",
                                labelsEnabled: !$scope.miniview,
                                titleFontSize: 10,
                                labelFunction: $scope.adjustValueAxisLabels
                            }
                        ],
                        "allLabels": [],
                        "dataProvider": data,
                        "export": {
                            "enabled": true
                        },
                        listeners: [{
                            event: "init",
                            method: setAfterInit
                        }]
                    });

                function setAfterInit(chart){
                    chart = chart.chart;
                    if(($scope.rtinterval && $scope.rtinterval !== 0)){
                        //trafficChart.titles[0].text = $scope.currentcounter.name + " Per Second";
                        delete chart.chartScrollbar;
                        if(rtMargin < 0) {
                            chart.graphs[0].connect = false;
                        }

                        chart.validateData();
                    }
                    else {
                        chart.chartCursor.addListener("selected", handleZoom);
                        if (!$scope.nozoom) {
                            chart.chartCursor.addListener("onShowCursor", function (event) {
                                event.chart.chartDiv.style.cursor = "zoom-in";
                            });
                            chart.chartCursor.addListener("onHideCursor", function (event) {
                                event.chart.chartDiv.style.cursor = "default";
                            });
                        }
                    }
                }
            }


            function handleZoom(event) {

                if($scope.rtinterval || $scope.nozoom){
                    trafficChart.chartCursor.clearSelection();
                    return;
                }
                var start = Math.min(event.start,event.end);
                var end = Math.max(event.start,event.end);
                if((end - start) > 300000){
                    $scope.from = new Date(event.start);
                    $scope.to = new Date(event.end);
                    trafficChart.chartCursor.clearSelection();
                }
                else{
                    trafficChart.chartCursor.clearSelection();
                    return;
                    //trafficChart.zoomToDates(new Date(event.start), new Date(event.end));
                    //trafficChart.chartCursor.clearSelection();
                }

            }

            function updateChart(data) {
                if(!trafficChart) {
                    return;
                }

                if(!data || data.length === 0){
                    data = [tempData];
                }

                if($scope.graphinterval){
                    trafficChart.categoryAxis.minPeriod = $scope.graphinterval + "fff";
                }

                if(!$scope.miniview){
                    if($scope.rtinterval && $scope.rtinterval !== 0){
                        trafficChart.graphs[0].title = $scope.currentcounter.label + " Per Second";
                        trafficChart.valueAxes[0].title = $scope.currentcounter.label + " Per Second";

                        //trafficChart.titles[0].text = $scope.currentcounter.name + " Per Second";
                        if(trafficChart.chartScrollbar){
                            delete trafficChart.chartScrollbar;
                        }
                    }
                    else {
                        if($scope.currentcounter.graphLabel){
                            trafficChart.graphs[0].title = $scope.currentcounter.graphLabel;
                            if($scope.currentcounter.graphLabel2){
                                trafficChart.graphs[1].title = $scope.currentcounter.graphLabel2;
                            }
                        }
                        else {
                            trafficChart.graphs[0].title = $scope.currentcounter.label;
                        }

                        trafficChart.valueAxes[0].title = $scope.currentcounter.label;
                        //trafficChart.titles[0].text = $scope.currentcounter.name + " By Dates";
                        if(!$scope.hidescroll){
                            trafficChart.categoryAxis.minPeriod = "2500fff";
                            trafficChart.chartScrollbar = chartScrollbar;
                        }
                    }
                }

                if($scope.legend){
                    trafficChart.legend.enabled = true;
                }
                else {
                    trafficChart.legend.enabled = false;
                   /* if(trafficChart.legend){
                        delete trafficChart.legend;
                    }*/
                }

               /* if($scope.graphinterval)
                    trafficChart.categoryAxis.minPeriod = $scope.graphinterval + "fff";*/

                trafficChart.graphs[0].connect = !(rtMargin < 0 && $scope.rtinterval);

                trafficChart.dataProvider = data;

                if($scope.graphinterval === 10000 && (!$scope.rtinterval || $scope.rtinterval === 0)){
                    handleZoom({start: $scope.from.getTime(), end: $scope.to.getTime()});
                }

                trafficChart.validateData();
            }

            $scope.$on('$destroy',function(){
                $scope.loaded = false;

                $interval.cancel(realtimeUpdateInterval);
                $scope.rtinterval = null;
            });
        }]
    };
}]);
